import { styled } from '@mui/material/styles';

interface StyledFormProps {
  margin?: string;
  maxWidth?: string;
  gap?: string;
  width?: string;
  marginTop?: string;
}

const StyledForm = styled('form')<StyledFormProps>`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap || '2rem'};
  margin: ${({ margin }) => margin || '0 auto'};
  margin-top: ${({ marginTop }) => marginTop || '100px'};
  max-width: ${({ maxWidth }) => maxWidth || '500px'};
  width: ${({ width }) => width || '100%'};
`;

export default StyledForm;
